export const REPORT_MEDIA_LINKS_TEMPLATE_URL =
  "https://docs.google.com/spreadsheets/d/1wrwIkpPmeUlekB-EO2oIT7jgiJR4BHqPDnsWciYckZ4/edit?usp=sharing";

export const REPORT_MEDIA_CSV_STORAGE_PATH = "reports/bulk-media-links";

export const ACCEPTED_CSV_EXTENSIONS = [".csv"];
